import { render, staticRenderFns } from "./pieOne.vue?vue&type=template&id=2965b3a2&scoped=true&"
import script from "./pieOne.vue?vue&type=script&lang=js&"
export * from "./pieOne.vue?vue&type=script&lang=js&"
import style0 from "./pieOne.vue?vue&type=style&index=0&id=2965b3a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965b3a2",
  null
  
)

export default component.exports